__webpack_require__.p = "/wp-content/plugins/keobongvip-plugin/build/";